





































import {Component, Prop, Watch, Mixins, Vue} from 'vue-property-decorator'
import {$} from 'simpli-web-sdk'
import {snakeCase} from 'lodash'
import {MixinFilter} from '@/components/mixins/MixinFilter'
import CargaCollection from '@/model/collection/CargaCollection'
import FilterDelivery from '@/components/filters/FilterDelivery.vue'
import {AppConfig} from '@/config/app.config'
import * as Helper from '@/helpers'
import Carga from '@/model/resource/Carga'
import DeliveryRequest from '@/model/request/DeliveryRequest'
import {DeliveryEvent} from '@/enums/DeliveryEvent'
import FilterToggle from '@/components/FilterToggle.vue'
import moment from 'moment'

const metaInfo = () => ({
  title: $.t('view.reports.deliveryIssue.title'),
})

@Component({
  metaInfo,
  components: {FilterToggle, FilterDelivery},
})
export default class ReportsDeliveryIssueView extends Mixins(MixinFilter) {
  AppConfig = AppConfig

  filter = new DeliveryRequest()
  collection = new CargaCollection(this.filter)

  shown = ['sigla', 'insumo', 'tipoFinalizacao', 'tipoCriacao', 'slaStatus', 'manifesto']

  async created() {
    this.filter.event = DeliveryEvent.OCCURRENCE_AND_RETURNED

    this.filter.startDate = moment().format()
  }

  async downloadData(xlsx = false) {
    const title = this.$t('view.reports.deliveryIssue.title') as string

    if (!xlsx) {
      await $.await.run(() => Helper.downloadCsv(title, '/user/carga/csv', this.filter, true, 3), 'download')
    } else {
      await $.await.run(() => Helper.downloadXlsx(
        title,
        '/user/carga/csv',
        this.filter,
        Carga,
        'Carga',
          true,
          3,
        ), 'download')
    }
  }
}
